import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ui-date-picker" }
const _hoisted_2 = {
  key: 1,
  class: "twoDateView"
}
const _hoisted_3 = ["readonly"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"15px"} }, "—", -1)
const _hoisted_5 = ["readonly"]
const _hoisted_6 = ["readonly"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "delimiter" }, "-", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon-calendar" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "date-time-wrapper",
  id: "dateTimeWrapper",
  ref: "dateTimeWrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_date_time = _resolveComponent("ui-date-time")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(this)), () => [
      _createElementVNode("div", {
        class: _normalizeClass(["input-group", { view2: _ctx.view2, wrong: _ctx.wrong }])
      }, [
        (_ctx.isDateRange && _ctx.view2)
          ? _renderSlot(_ctx.$slots, "isDateRange", { key: 0 }, () => [
              (!_ctx.changeDateManual)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "isDateRange",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.targetDatetime && _ctx.targetDatetime(...args)))
                  }, _toDisplayString(_ctx.inner2DateFormatted.dateFrom) + " - " + _toDisplayString(_ctx.inner2DateFormatted.dateTo), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                      onKeydown: [
                        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPressEnterLeft && _ctx.onPressEnterLeft(...args)), ["enter"])),
                        _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPressEnterLeft && _ctx.onPressEnterLeft(...args)), ["tab"]))
                      ],
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inner2DateFormatted.dateFrom) = $event)),
                      class: _normalizeClass([{ transformer: _ctx.transformer }, 'twoDate', 'left']),
                      readonly: !_ctx.changeDateManual
                    }, null, 42, _hoisted_3), [
                      [_vModelText, _ctx.inner2DateFormatted.dateFrom],
                      [_directive_click_outside, _ctx.onPressEnterLeft]
                    ]),
                    _hoisted_4,
                    _withDirectives(_createElementVNode("input", {
                      onKeydown: [
                        _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPressEnterRight && _ctx.onPressEnterRight(...args)), ["enter"])),
                        _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPressEnterRight && _ctx.onPressEnterRight(...args)), ["tab"]))
                      ],
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inner2DateFormatted.dateTo) = $event)),
                      class: _normalizeClass([{ transformer: _ctx.transformer }, 'twoDate', 'right']),
                      readonly: !_ctx.changeDateManual
                    }, null, 42, _hoisted_5), [
                      [_vModelText, _ctx.inner2DateFormatted.dateTo],
                      [_directive_click_outside, _ctx.onPressEnterRight]
                    ])
                  ]))
            ])
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.innerDateFormatted) = $event)),
              class: _normalizeClass([{ transformer: _ctx.transformer }, { focus: _ctx.iconFocused }]),
              readonly: !_ctx.changeDateManual,
              onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
              onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
              onKeydown: [
                _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onTab && _ctx.onTab(...args)), ["tab"])),
                _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
              ]
            }, null, 42, _hoisted_6)), [
              [_vModelText, _ctx.innerDateFormatted]
            ]),
        _createElementVNode("div", {
          class: _normalizeClass(["icon-calendar", [{ transformer: _ctx.transformer }]]),
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.targetDatetime && _ctx.targetDatetime(...args)))
        }, null, 2),
        (_ctx.isDateRange && !_ctx.view2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.innerSecondDateFormatted) = $event))
              }, null, 512), [
                [_vModelText, _ctx.innerSecondDateFormatted]
              ]),
              _hoisted_8
            ], 64))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_ctx.innerShowDatetime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_ui_date_time, {
            ref: "FirstDatePicker",
            date: this.innerDate,
            dateSecond: _ctx.isDateRange ? this.innerSecondDate : null,
            onChange: _ctx.changeDate,
            minimumDate: _ctx.minimumDate,
            minimumView: _ctx.minimumView,
            maximumView: _ctx.maximumView,
            initialView: _ctx.initialView,
            isDateRange: _ctx.isDateRange,
            eventDates: _ctx.eventDates || [],
            showCurrentDate: _ctx.showCurrentDate,
            letSelectAllDays: _ctx.letSelectAllDays
          }, null, 8, ["date", "dateSecond", "onChange", "minimumDate", "minimumView", "maximumView", "initialView", "isDateRange", "eventDates", "showCurrentDate", "letSelectAllDays"])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}